import type { SiteConfig } from '../context/SiteConfigContext'

/** GST UI and tax apply only when enabled in company master and GSTIN is set. */
export function isGstEnabled(config: Pick<SiteConfig, 'gst_enabled' | 'gstin_number'>): boolean {
  return config.gst_enabled === 'true' && Boolean(config.gstin_number?.trim())
}

export function companyLegalName(config: Pick<SiteConfig, 'company_legal_name' | 'brand_name'>): string {
  const name = config.company_legal_name?.trim()
  if (name) return name
  return `${config.brand_name} Jewellery Pvt. Ltd.`
}
